<template>
  <!-- eslint-disable vue/no-v-html -->
  <div
    v-bind="$attrs"
    class="markdown"
    v-html="rendered"
  />
  <!-- eslint-enable -->
</template>

<script setup>
import { computed } from 'vue'

import { useUserService } from '@/users/services'

import markdown from './markdownRenderer'

const { usersByUsername } = useUserService()

const props = defineProps({
  source: {
    required: true,
    type: String,
  },
  mentions: {
    default: false,
    type: Boolean,
  },
})

const markdownEnv = computed(() => {
  if (props.mentions && usersByUsername.value) {
    return { usersByUsername: usersByUsername.value }
  }
  return {}
})

const rendered = computed(() => markdown.render(props.source, markdownEnv.value))
</script>

<style scoped lang="sass">
@use '@/css/content'

.markdown
  overflow-wrap: break-word

.markdown ::v-deep()
  @include content.formatting
</style>
